<template>
    <div style="max-height: 30rem; overflow-y: auto;">
        <b-card-text v-if="indumentarias" class="mt-3">
            <template v-for="indumentaria in indumentarias">
                <h6 :key="indumentaria.id">- {{ indumentaria.nombre }}:</h6>
                <template v-for="(talla, index) in indumentaria.tallas">
                    <h6 v-if="talla.cantidad > 0" :key="talla.id + '_' + index" class="pl-4">- {{ talla.nombre }}: <span class="red">{{ talla.cantidad }} unidades</span></h6>
                </template>
            </template>
        </b-card-text>
    </div>
</template>

<script>
export default {
    props: ['ruta'],
    data() {
        return {
            loading: false,
            indumentarias: null
        }
    },
    methods: {
        getIndumentarias() {
            this.loading = true;

            let params = {
                lista_id: this.lista_id,
                filters: {}
            };
            this.$store.dispatch(this.config.getVuexAlias(this.ruta), params).then(res => {
                this.indumentarias = res.data.data_indumentarias;
            }).finally(() => this.loading = false);
        },
    },
    computed: {
        lista_id() {
            return this.$route.params.lista_id;
        } 
    },
    created() {
        this.getIndumentarias();
    }
}
</script>